
import { ApiKeyManagement } from "@/components/api/ApiKeyManagement";
import { WebhookMonitor } from "@/components/api/WebhookMonitor";
import { HttpSmsInstructions } from "@/components/profile/HttpSmsInstructions";
import { Card, CardContent } from "@/components/ui/card";

const ApiDocs = () => {
  return (
    <div className="container mx-auto px-4 py-8 space-y-8">
      <h1 className="text-3xl font-bold mb-8">API Documentation</h1>
      
      <div className="grid gap-8 md:grid-cols-2">
        <div className="space-y-8">
          <ApiKeyManagement />
          <Card className="bg-white/90 backdrop-blur-lg border-pink-100">
            <CardContent className="p-6">
              <HttpSmsInstructions />
            </CardContent>
          </Card>
        </div>
        
        <div>
          <WebhookMonitor />
        </div>
      </div>
    </div>
  );
};

export default ApiDocs;
